import { Flex, Box } from './Flexbox/Flex';

type ImageProps = {
  imageUrl: string;
  isGrayscale: boolean;
};

const Image = ({ imageUrl, isGrayscale }: ImageProps) => (
  <div
    className={`bg-cover bg-no-repeat min-h-[130px] min-w-[130px] max-w-[130px] ltr:mr-400 rtl:ml-400 ${
      isGrayscale ? 'filter grayscale' : ''
    }`}
    style={{ backgroundImage: `url(${imageUrl})` }}
  />
);

type Props = {
  readonly imageUrl?: string;
  readonly dataTest?: string;
  readonly children: JSX.Element;
  readonly isGrayscale?: boolean;
};

const PictureCard = ({ imageUrl, isGrayscale = false, children, dataTest }: Props): JSX.Element => {
  return (
    <Flex
      backgroundColor="paletteWhite"
      borderRadius="borderRadius100"
      overflow="hidden"
      width="100%"
      height="100%"
      data-test={dataTest}
      alignItems="stretch"
      maxHeight="200px"
    >
      <Image imageUrl={imageUrl} isGrayscale={isGrayscale} />
      <Box paddingY="400" width="100%">
        {children}
      </Box>
    </Flex>
  );
};

export default PictureCard;
